import { z } from 'zod/v4';

export const configuratorMaterialSchema = z.object({
  id: z.string(),
  description: z.string().optional().nullable(),
  stock_um: z.string(),
  unit_material_cost: z.number(),
});
